__turbopack_context__.v({
  "buttonContainer": "rrJvRG_buttonContainer",
  "container": "rrJvRG_container",
  "heading": "rrJvRG_heading",
  "selectionButton": "rrJvRG_selectionButton",
  "selectionButtonText": "rrJvRG_selectionButtonText",
  "verticalRule": "rrJvRG_verticalRule",
});
